import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "ImportCompleted": "Import Completed",
  "ImportError": "Import Error",
  "HaveApprovalAlert": "New {type} application awaiting your approval",
  "VillageDisburseSuccess": "Loan Disbursement Complete",
  "Failed": "Failed",
  "SystemMessage": "System Message",
  "Approval": "Approve",
  "success": "Success",
  "Reject": "Reject",
  "View": "View",
  "Export": "Export"
})
i18n.mergeLocaleMessage('zh', {
  "ImportCompleted": "导入完成",
  "ImportError": "导入失败",
  "HaveApprovalAlert": "你有一个新的{type}申请等待审批",
  "VillageDisburseSuccess": "放款处理完成",
  "Failed": "失败",
  "SystemMessage": "系统消息",
  "Approval": "同意",
  "success": "成功",
  "Reject": "Reject",
  "View": "查看",
  "Export": "导出"
})
i18n.mergeLocaleMessage('mm', {
  "ImportCompleted": "တင်သွင်းမှု ပြီးစီးပါပြီ",
  "ImportError": "တင်သွင်းမှု အမှား",
  "HaveApprovalAlert": "သင့်တွင် {type}  အားအတည်ပြုရန် တစ်ခုရှိသည်။",
  "VillageDisburseSuccess": "ကျေးရွာငွေပေးချေမှု ပြီးဆုံးခြင်း",
  "Failed": "မအောင်မြင်ပါ",
  "SystemMessage": "System မက်ဆေ့ချ်",
  "Approval": "လက်ခံခြင်း",
  "success": "အောင်မြင်သည်",
  "Reject": "Reject",
  "View": "ကြည့်မည်",
  "Export": "ထုတ်မည်"
})
  